module.exports = __webpack_public_path__ + "static/media/page-header.32f22c59.jpg";